import axios from "axios";

const BASE_URL = process.env.NODE_ENV === "production" ? "https://wgsitetest.com" : "http://localhost:4001";

// console.log(process.env.NODE_ENV);
// console.log(BASE_URL);

export default axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache, no-store, must-revalidate",
    Pragma: "no-cache",
    Expires: "0",
  },
  withCredentials: true,
});
